import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=6b3f943e&scoped=true&"
import script from "./PageFooter.vue?vue&type=script&lang=js&"
export * from "./PageFooter.vue?vue&type=script&lang=js&"
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=6b3f943e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3f943e",
  null
  
)

export default component.exports